module.exports = __webpack_public_path__ + "static/img/bg-7.f9c97bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-7.png
// module id = qJm9
// module chunks = 0